<div class="address-form" [formGroup]="form()">
    <div class="address-form__field">
        <label class="body-1" [class.invalid-control]="isInvalid('addressLine1')" [for]="idPrefix() + '-address-line1'"
            >Address *</label
        >
        <mat-form-field appearance="outline">
            <input
                [id]="idPrefix() + '-address-line1'"
                class="body-0"
                autocomplete="address-line1"
                formControlName="addressLine1"
                libTrimmedValue
                matInput
            />
            <mat-error>
                <mat-icon svgIcon="ico_alert" />
                Enter the street address.
            </mat-error>
        </mat-form-field>
    </div>

    <div class="address-form__row">
        <div class="address-form__field">
            <label class="body-1" [class.invalid-control]="isInvalid('city')" [for]="idPrefix() + '-city'">City *</label>
            <mat-form-field appearance="outline">
                <input
                    [id]="idPrefix() + '-city'"
                    class="body-0"
                    autocomplete="address-level2"
                    formControlName="city"
                    libTrimmedValue
                    matInput
                />
                <mat-error>
                    <mat-icon svgIcon="ico_alert" />
                    Enter the city.
                </mat-error>
            </mat-form-field>
        </div>

        <div class="address-form__field">
            <label [id]="idPrefix() + '-state-label'" class="body-1" [class.invalid-control]="isInvalid('stateCode')"
                >State *</label
            >
            <mat-form-field appearance="outline" class="v2-select">
                <mat-select
                    [id]="idPrefix() + '-state'"
                    formControlName="stateCode"
                    [attr.aria-labelledby]="idPrefix() + '-state-label'"
                >
                    @for (state of states; track state.code) {
                        <mat-option [value]="state.code">{{ state.name }}</mat-option>
                    }
                </mat-select>
                <mat-error>
                    <mat-icon svgIcon="ico_alert" />
                    Choose the state.
                </mat-error>
            </mat-form-field>
        </div>

        <div class="address-form__field">
            <label class="body-1" [class.invalid-control]="isInvalid('postalCode')" [for]="idPrefix() + '-postal-code'"
                >ZIP code *</label
            >
            <mat-form-field appearance="outline">
                <input
                    [id]="idPrefix() + '-postal-code'"
                    class="body-0"
                    autocomplete="postal-code"
                    formControlName="postalCode"
                    inputmode="numeric"
                    libTrimmedValue
                    matInput
                />
                <mat-error>
                    <mat-icon svgIcon="ico_alert" />
                    @if (form().controls.postalCode.hasError('required')) {
                        Enter the ZIP code.
                    } @else {
                        Enter a 5-digit ZIP code (for example: 10001 or 10001-1234).
                    }
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</div>
